import { useState } from 'react';

import { useUserStrategies } from '../../../context/UserStrategies';
import { PieAndTable } from './PieAndTable';
import { CreateList } from './CreateList';
import { PlaceholderStrategy } from '../../Strategies/Placeholder';
import { t } from 'i18next';

const ALLOCATION_TYPES = [
  { title: 'Asset class', groupBy: 'STRATEGIES' },
  // { title: 'Sectors', groupBy: 'STRATEGIES' },
  { title: 'Custodian', groupBy: 'SOURCE' },
  { title: 'Inspiration sources', groupBy: 'INSPIRATION' },
  // { title: 'Currency', groupBy: 'STRATEGIES' },
  // { title: 'Continent', groupBy: 'STRATEGIES' },
  // { title: 'Exchange', groupBy: 'STRATEGIES' },
  // { title: 'Geographic area', groupBy: 'STRATEGIES' },
] as const;

export const COLUMNS_STRATEGY_PERFORMANCE = [
  'ASSET CLASS',
  'TOT VALUE',
  'ALLOCATION',
] as const;

export type TCompareWidgetProps = {
  width: number;
};

export const StrategiesAllocation = ({ width }: TCompareWidgetProps) => {
  const { strategies } = useUserStrategies();
  const [groupBy, setGroupBy] = useState<
    'STRATEGIES' | 'SOURCE' | 'INSPIRATION'
  >('STRATEGIES');

  const [selectedStrategies, setSelectedStrategies] = useState(
    strategies.slice(0, 2).map(({ id }) => id)
  );

  const handleSelectedStrategies = (id: string, i: number) => {
    const newSelectedStrategies = i
      ? [selectedStrategies[0], id]
      : [id, selectedStrategies[1]];

    setSelectedStrategies(newSelectedStrategies);
  };

  return strategies.length < 2 ? (
    <PlaceholderStrategy
      title={t('placeholders.compareStrategies.title')}
      subtitle={t('placeholders.compareStrategies.subtitle')}
    />
  ) : (
    <>
      <CreateList items={[...ALLOCATION_TYPES]} cb={setGroupBy} />
      <div
        className={`
          flex
          h-full
          divide-x
          divide-grey-10
          dark:divide-grey-70
          ${width === 1 && 'flex-col'}
        `}
      >
        {selectedStrategies.map((selectedId, i) => (
          <PieAndTable
            width={width}
            key={selectedId}
            groupBy={groupBy}
            selectedId={selectedId}
            selectedStrategies={selectedStrategies}
            handleSelectedStrategies={(id) => handleSelectedStrategies(id, i)}
          />
        ))}
      </div>
    </>
  );
};
